<template>
  <div class="consent-banner" role="dialog" aria-labelledby="consent-banner-title">
    <div class="consent-banner__inner">
      <h2 id="consent-banner-title" class="consent-banner__title">{{ copy.bannerTitle }}</h2>
      <p class="consent-banner__text">{{ copy.bannerText }}</p>

      <button type="button" class="consent-banner__link" @click="openPrivacy">
        {{ copy.privacyLink }}
      </button>

      <button type="button" class="consent-btn consent-btn--primary" @click="$emit('acknowledge')">
        {{ copy.acknowledge }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { CONSENT_COPY } from '@/constants/consent';
import { openLegalDocument } from '@/utils/openLegalDocument';

defineEmits(['acknowledge']);

const copy = CONSENT_COPY;

const openPrivacy = () => openLegalDocument('datenschutz');
</script>

<style lang="scss" scoped>
@use '@/styles/consent.scss' as consent;

.consent-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10050;
  padding: 0 12px calc(12px + env(safe-area-inset-bottom, 0px));
  pointer-events: none;
}

.consent-banner__inner {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 16px 16px;
  border-radius: 16px 16px 0 0;
  background: #fff;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.14);
  pointer-events: auto;
}

.consent-banner__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 500;
  color: #1a1a1a;
}

.consent-banner__text {
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.45;
  color: #555;
}

.consent-banner__link {
  display: inline-block;
  margin-bottom: 16px;
  padding: 0;
  border: none;
  background: none;
  color: consent.$consent-accent;
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
}

.consent-btn {
  width: 100%;
  min-height: 44px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s;

  &:active {
    opacity: 0.8;
  }

  &--primary {
    border: none;
    background: consent.$consent-accent;
    color: #fff;
  }
}
</style>
